import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../../components/Common/Actions";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import ListPageLayout from "../../../components/Layout";
import Deletepopup from "../../../components/Modal/Deletepopup";
import useDebouncedSearch from "../../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../../components/Utils/hooks/useSortHandler";

const Comments = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  // Sorting
  const [sort, setSort] = useState("");
  const [sortName, setSortName] = useState("Newest First");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () =>
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 })),
  );

  // Delete state
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}post-a-comment/list`,
      initialParams: {
        sort,
        searchText: search,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler(
    "post-a-comment",
    fetchData,
    setShowDelete,
  );

  useEffect(() => {
    setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.skip, pagination.limit, sort, search]);

  const handleView = (id) => navigate(`/view-comment/${id}`);

  const columns = [
    {
      title: "S.No",
      key: "serial",
      render: (text, record, index) =>
        Number(pagination.skip || 0) + (index + 1),
      width: 80,
      fixed: "left",
    },
    {
      title: "Blog Name",
      key: "blogName",
      width: 150,
      render: (_, record) => {
        const blog = records.find((b) => b._id === record.id);
        return blog ? blog.title : "N/A";
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      width: 150,
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
    },
    {
      title: "Comments",
      dataIndex: "comment",
      key: "comment",
      width: 700,
    },
    {
      title: "Date & Time",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) =>
        `${moment(createdAt).format("DD-MM-YYYY")} & ${moment(createdAt).format(
          "LT",
        )}`,
      width: 250,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <Actions
            isDelete={true}
            isView={true}
            onClickView={() => handleView(record._id)}
            onClickDelete={() => {
              setDeleteId(record._id);
              setShowDelete(true);
            }}
          />
        </div>
      ),
    },
  ];

  const dataSource = records?.map((el) => ({
    ...el,
    key: el._id,
  }));

  const breadcrumbsList = [
    { text: "Pop-up Data", link: "/comment" },
    { text: "Post a Comment", link: "" },
  ];
  useEffect(() => {
    records && setLoader(false);
  }, [records]);

  return (
    <ListPageLayout
      loader={loader}
      breadcrumbs={
        <Breadcrumbs
          className="healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      filters={
        <DoctorsFilterOptions
          limit={pagination.limit}
          setLimit={(val) =>
            setPagination((prev) => ({
              ...prev,
              limit: val,
              skip: 0,
              currentPage: 1,
            }))
          }
          search={search}
          onChange={debouncedSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          filter_records={() => {}}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource,
        className: "mx-3 pt-2 table-scrollable viewMed_table",
      }}
      totalCount={totalCount}
      pagination={pagination}
      onPageChange={(selected) => handlePageChange({ selected })}
    >
      {showDelete && (
        <Deletepopup
          handleDelete={() => handleDelete(deleteId)}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}
    </ListPageLayout>
  );
};

export default Comments;
